<template>
  <div class="error-404">
    <picture>
      <source media="(min-width: 944px)" srcset="@/assets/img/404/bg-large.jpg">
      <source media="(min-width: 768px)" srcset="@/assets/img/404/bg-medium.jpg">
      <img src="@/assets/img/404/bg.jpg" ref="Bg" alt="URC Home top background">
    </picture>
    <v-container>
      <v-heading level="h4">Parece que esta pagina não existe</v-heading>
      <v-btn model="color-a" tag="router-link" to="/" :small="true">
        Ir para pagina principal
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Btn from '@/components/uikit/Btn.vue';

export default {
  name: 'Error404',
  metaInfo: {
    title: 'Erro 404',
  },
  components: {
    'v-container': Container,
    'v-heading': Heading,
    'v-btn': Btn,
  },
};
</script>

<style lang="scss" scoped>
$component: '.error-404';
#{$component} {
  display: grid;
  position: relative;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  picture {
    z-index: 1;
    grid-column: 1 / 2;
    grid-row: 1;
    img {
      position: relative;
      display: block;
      max-width: 100%;
      left: 50%;
      transform: translate(-50%);
    }
  }
  .container {
    z-index: 2;
    grid-column: 1 / 2;
    grid-row: 1;
    margin: auto;
    text-align: center;
  }
}
</style>
